import React from "react";
import SectionWrapper from "components/elements/SectionWrapper";

import styles from "./TabsSection.module.scss";

const TabsSection = (props) => {
    const { alignment, data } = props;

    return (
        <div className={`text-${alignment ? alignment : "left"}`}>
            <SectionWrapper 
                className={`${styles.TabsSection}`} 
                fluid={false} 
                {...props}
            >
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {data && data.map((tab, index) => (
                        <li className="nav-item" key={index} role="presentation">
                            <button
                                className={`nav-link ${index === 0 ? "active" : ""}`}
                                id={`${tab.id}-tab`}
                                data-bs-toggle="tab"
                                data-bs-target={`#${tab.id}`}
                                type="button"
                                role="tab"
                                aria-controls={tab.id}
                                aria-selected={index === 0 ? "true" : "false"}
                            >
                                {tab.title}
                            </button>
                        </li>
                    ))}
                </ul>
                <div className="tab-content" id="myTabContent">
                    {data && data.map((tab, index) => (
                        <div
                            key={index}
                            className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                            id={tab.id}
                            role="tabpanel"
                            aria-labelledby={`${tab.id}-tab`}
                        >
                            {tab.content}
                        </div>
                    ))}
                </div>
            </SectionWrapper>
        </div>
    );
};

export default TabsSection;